import { FunctionComponent, useEffect } from 'react';
import { useDispatch } from '@cbridge-utils/react-redux';
import { DictTimezoneAction } from '../../dictTimezone.action';

export const DictTimezoneListSubscriber: FunctionComponent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(DictTimezoneAction.loadList.started(undefined));
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(DictTimezoneAction.destroy());
    };
  }, [dispatch]);

  return null;
};
